import * as activityLogger from "../helpers/activity-logger";
import { getDeviceType } from './deviceUtils';


$(document).ready(function() {
    setTimeout(function() {
        const $iframe = $('#jsd-widget');

        if ($iframe.length && $iframe[0].contentDocument) {
            const $iframeContent = $($iframe[0].contentDocument);
            const $button = $iframeContent.find('#help-button');
            
            if ($button.length) {
                $button.on('click', function() {
                    const deviceType = getDeviceType();
                    activityLogger.logActivity('Feedback widget', $('body').data('route'), ["clicked", `source: ${deviceType}`]);
                });
            }
        }
    }, 5000);
});
